import { useMutation } from '@apollo/client';
import {
    GenerateFinancialOverviewRequest,
    GenerateFinancialOverviewResponse,
    CITRIN_GENERATE_FINANCIAL_OVERVIEW,
} from '..';
import { FinancialOverview, FinancialOverviewInput } from '../../shared/types';

type CreateMutationFunction = (request: FinancialOverviewInput) => Promise<FinancialOverview>;

export const useGenerateFinancialOverviewMutation = () => {
    const [mutation, { loading }] = useMutation<GenerateFinancialOverviewResponse, GenerateFinancialOverviewRequest>(
        CITRIN_GENERATE_FINANCIAL_OVERVIEW
    );

    const generateFinancialOverview: CreateMutationFunction = async (request) => {
        const result = await mutation({ variables: { request } });
        return result?.data?.CITRIN_MGT_generateFinancialOverview ?? null;
    };

    return { generateFinancialOverview, loading };
};
